<template>
    <div class="tab-pane fade px-4 py-4 show"
         :class="active ? 'active' : ''"
         :id="id"
         role="tabpanel"
         :aria-labelledby="ariaLabel"
    >
        <slot />
    </div>
</template>

<script>
export default {
    name: "AuthTabPane",
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: true,
        },
        ariaLabel: {
            type: String,
            required: true,
        }
    }
}
</script>
